module.exports = __webpack_public_path__ + "static/img/la_liga.da1126e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/la_liga.png
// module id = yj2b
// module chunks = 1